import React, { useState, useEffect, useContext } from 'react';
import BaseComponentInternas from '../../Components/BaseComponentInternas';
import DestaquesComponent from '../../Components/DestaquesComponent';
import { ContextDestaques } from '../../services/destaques';
import { Spinner } from '../../Components/StyledComponent';
import IndicaMais from '../../Components/IndicaMais';

const Destaques = (props) => {
  const [destaques, setDestaques] = useState([]);
  const [idSelecionado, setIdSelecionado] = useState('');
  const [loading, setLoading] = useState(true);

  const { getAllDestaques } = useContext(ContextDestaques);

  useEffect(() => {
    if (props.location.state == undefined) loadDestaques();
    else {
      setDestaques(props.location.state.destaques);
      setIdSelecionado(props.location.state.idSelecionado);
      setLoading(false);
    }
  }, []);

  async function loadDestaques() {
    let result = await getAllDestaques();
    setDestaques(result);
    setIdSelecionado(0);
    setLoading(false);
  }

  if (loading) return <Spinner />;

  // ATENÇÃO -> PARA PASSAR A PROP PELA PÁGINA TEM DE ALTERAR TAMBÉM O QUE É RENDERIZADO NO ARQUIVO routes.js

  return (
    <BaseComponentInternas>
      <DestaquesComponent destaques={destaques} idSelecionado={idSelecionado} />
      <IndicaMais />
    </BaseComponentInternas>
  );
};

export default Destaques;
